import { Button } from '../primitives/Button';

export interface FleetPickerRow {
  id: string;
  label: string;
  available: number;
  value: number;
}

export interface FleetPickerProps {
  rows: FleetPickerRow[];
  onChange: (id: string, value: number) => void;
  totalShips: number;
  cargo: number;
  fuel: number;
  fuelAvailable?: number;
  travelTimeMs?: number;
  formatDuration?: (milliseconds: number) => string;
}

/** Exact fleet selection shared by camp and galaxy attack views. */
export function FleetPicker({
  rows,
  onChange,
  totalShips,
  cargo,
  fuel,
  fuelAvailable,
  travelTimeMs,
  formatDuration = (milliseconds) => `${Math.ceil(milliseconds / 60_000)} min`,
}: FleetPickerProps) {
  const fuelInsufficient = fuelAvailable !== undefined && fuel > fuelAvailable;

  return (
    <div className="space-y-2">
      <div className="grid gap-1.5">
        {rows.map((row) => (
          <div key={row.id} className="flex items-center gap-2 text-xs">
            <span className="min-w-28 flex-1 text-content-secondary">{row.label}</span>
            <Button size="sm" variant="ghost" onClick={() => onChange(row.id, Math.max(0, row.value - 1))} aria-label={`${row.label} reduzieren`}>−</Button>
            <input
              className="h-7 w-16 rounded-control border border-edge bg-surface-3 text-center text-content"
              type="number"
              min={0}
              max={row.available}
              value={row.value}
              onChange={(event) => onChange(row.id, Math.min(row.available, Math.max(0, Number(event.target.value) || 0)))}
              aria-label={row.label}
            />
            <Button size="sm" variant="ghost" onClick={() => onChange(row.id, Math.min(row.available, row.value + 1))} aria-label={`${row.label} erhöhen`}>+</Button>
            <Button size="sm" variant="secondary" onClick={() => onChange(row.id, row.available)}>Max</Button>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-label text-content-muted">
        <span>{totalShips} Schiffe</span>
        <span>{cargo.toLocaleString('de-DE')} Laderaum</span>
        <span className={fuelInsufficient ? 'text-danger-bright' : 'text-content-secondary'}>
          {fuel} Isotop-3{fuelAvailable !== undefined ? ` / ${fuelAvailable}` : ''}
        </span>
        {travelTimeMs !== undefined ? <span>Flugzeit {formatDuration(travelTimeMs)}</span> : null}
      </div>
    </div>
  );
}
